import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import axios from "axios";
import ThinksToKnowStatus from './ThinksToKnowStatus';
const DestinationWedTTK = () => {
    const serviceOptions = checkboxData.photographyServiceOfferOption;
    const djPolicyOption = checkboxData.djPolicyOption;
    const decorPolicyOption = checkboxData.decorPolicyOption;
    const cateringPolicyOption = checkboxData.caterPolicyOptions;
    const alcoholPolicyOption = checkboxData.alcoholPolicyOption;
    const workingSinceOption = checkboxData.workSinceOption;
    const spaceOption = checkboxData.spaceOption;
    const smallPartiesOption = checkboxData.smallPartyOption;
    const parkingOption = checkboxData.parkingOption;
    const destinationOption = checkboxData.destinationVenue;
    const { user, language, token } = useUserAuth();
    const merchant_id = user.uid;
    // console.log("merchant id ", merchant_id)
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState({});
    // console.log("merchant data",merchant)
    const [data, setData] = useState({
        parkingSize: '',
        vegPrice: '',
        nonVegPrice: '',
        roomCount: '',
        avgRoomPrice: '',
        workingSince: [],
        parking: [],
        smallPartiesVenue: [],
        space: [],
        catering: [],
        decorPolicy: [],
        alcoholPolicy: [],
        djPolicy: [],
        destination: [],
        starRating: ''
    })

    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            // console.log("data destination wedding",data)
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id)
            getSingleDocumentHandler()
    }, [merchant_id, token])
    const formHandler = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setData({ ...data, [name]: value })
    }

    const btnHandler = async (e) => {
        e.preventDefault();
        const {
            parkingSize,
            vegPrice,
            nonVegPrice,
            roomCount,
            avgRoomPrice,
            workingSince,
            smallPartiesVenue,
            space,
            catering,
            decorPolicy,
            alcoholPolicy,
            djPolicy,
            starRating,
            venueCapacity
        } = data; // Using provided data

        if (parkingSize !== '' && vegPrice !== '' && nonVegPrice !== '' && roomCount !== '' && avgRoomPrice !== '' && venueCapacity !== '') {
            try {
                const apiData = {
                    id: merchant_id,
                    details: {
                        parkingSize,
                        vegPrice,
                        nonVegPrice,
                        roomCount,
                        avgRoomPrice,
                        starRating: starRating || '',
                        workingSince,
                        venueCapacity,
                        smallPartiesVenue,
                        space,
                        catering,
                        decorPolicy,
                        alcoholPolicy,
                        djPolicy
                    }
                };
                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, apiData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(apiData.details);
                    setTtkEditMode(!false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(!false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(!false);
                }
                // setMerchant(apiData.details);
                setTtkEditMode(!ttkEditMode);
            } catch (err) {
                console.log(`Error ${err}`);
                toast.error('An error occurred while updating the data.');
            }
        } else {
            toast.error('Please fill all the mandatory fields.');
        }
    };
    const workingSinceHandler = (e) => {
        setData({ ...data, workingSince: e })
    }
    const parkingHandler = (e) => {
        setData({ ...data, parking: e })
    }
    const smallPartiesVenueHandler = (e) => {
        setData({ ...data, smallPartiesVenue: e })
    }
    const spaceHandler = (e) => {
        setData({ ...data, space: e })
    }
    const cateringHandler = (e) => {
        setData({ ...data, catering: e })
    }
    const decorHandler = (e) => {
        setData({ ...data, decorPolicy: e })
    }
    const alcoholPolicyHandler = (e) => {
        setData({ ...data, alcoholPolicy: e })
    }
    const djPolicyHandler = (e) => {
        setData({ ...data, djPolicy: e })
    }
    const destinationHandler = (e) => {
        setData({ ...data, destination: e })
    }
    const [ttkEditMode, setTtkEditMode] = useState(false)
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header bg-primary text-white'>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>How many Cars can be Parked at Your Venue?</th>
                                                            <th style={{ width: '25%' }}>Starting Veg Price (Per Plate) </th>
                                                            <th>Star Rating</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>
                                                            {/* <td>{
                                                                merchant.parking?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td> */}
                                                            <td>{merchant.parkingSize}</td>
                                                            <td>&#8377;{merchant.vegPrice}
                                                                <small className='text-success' style={{
                                                                    fontWeight: 'bold'
                                                                }}> Per Plate</small>
                                                            </td>
                                                            <td>{merchant.starRating}</td>
                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Starting Non Veg Price (Per Plate)</th>
                                                            <th>Small Party Venue</th>
                                                            <th>Space</th>
                                                            <th>Total No. of Rooms</th>
                                                        </tr>
                                                        <tr>
                                                            <td>&#8377; {merchant.nonVegPrice}
                                                                <small className='text-danger' style={{
                                                                    fontWeight: 'bold'
                                                                }}> Per Plate</small>
                                                            </td>
                                                            <td>{
                                                                merchant.smallPartiesVenue
                                                                    ?.map((item, index) => {
                                                                        return <p key={index}>{item.value}</p>
                                                                    })
                                                            }</td>
                                                            <td>{
                                                                merchant.space
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span>{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>
                                                            <td>{merchant.roomCount}</td>
                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Avg Room Price</th>
                                                            <th>Catering Policy</th>
                                                            <th>Decor Policy</th>
                                                            <th>Alcohol Policy</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{merchant.avgRoomPrice}</td>
                                                            <td>{
                                                                merchant.catering

                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span>{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.decorPolicy
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span >{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>
                                                            <td>{
                                                                merchant.alcoholPolicy
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span>{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>
                                                        </tr>

                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Dj Policy </th>
                                                            <th>Max Capacity  </th>
                                                        </tr>

                                                        <tr>
                                                            <td>{
                                                                merchant.djPolicy?.map((item, index) => {
                                                                    return (
                                                                        <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span>{item.value} </span>
                                                                        </span>
                                                                    )
                                                                })
                                                            }</td>
                                                            <td>{merchant.venueCapacity}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn btn-primary mb-2' onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={btnHandler}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            defaultValue={merchant.workingSince}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            onChange={workingSinceHandler}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>How many cars can be parked at your venue? <span className='text-danger'>*</span></label>
                                                        <input type='number' placeholder='How many cars can be parked at your venue?' name="parkingSize" value={data.parkingSize} onChange={formHandler} className='form-control' />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Starting Veg Price (Per Plate)<span className='text-danger'>*</span></label>
                                                        <input type='number' placeholder='Veg Price Per Plate' name="vegPrice" value={data.vegPrice} onChange={formHandler} className='form-control' />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Starting Non Veg Price (Per Plate)<span className='text-danger'>*</span></label>
                                                        <input type='number' placeholder='Non Veg Price Per Plate' name="nonVegPrice" value={data.nonVegPrice} onChange={formHandler} className='form-control' />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Small Party Venue <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            defaultValue={merchant.smallPartiesVenue}
                                                            isMulti
                                                            options={smallPartiesOption}
                                                            selected
                                                            onChange={smallPartiesVenueHandler}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Space <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            defaultValue={merchant.space}
                                                            isMulti
                                                            options={spaceOption}
                                                            selected
                                                            onChange={spaceHandler}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Total No. of Rooms <span className='text-danger'>*</span></label>
                                                        <input type='number' placeholder='Total No. of Rooms' name="roomCount" value={data.roomCount} onChange={formHandler} className='form-control' />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Average Room Price <span className='text-danger'>*</span></label>
                                                        <input type='number' placeholder='Average Room Price' name="avgRoomPrice" value={data.avgRoomPrice || merchant.avgRoomPrice} onChange={formHandler} className='form-control' />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Catering Policy <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            defaultValue={merchant.cateringPolicy}
                                                            isMulti
                                                            options={cateringPolicyOption}
                                                            selected
                                                            onChange={cateringHandler}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Decor Policy <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            defaultValue={merchant.decorPolicy}
                                                            isMulti
                                                            options={decorPolicyOption}
                                                            selected
                                                            onChange={decorHandler}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Alcohol Policy <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            defaultValue={merchant.alcoholPolicy}
                                                            isMulti
                                                            options={alcoholPolicyOption}
                                                            selected
                                                            onChange={alcoholPolicyHandler}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>DJ Policy <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={true}
                                                            defaultValue={merchant.djPolicy}
                                                            isMulti
                                                            options={djPolicyOption}
                                                            selected
                                                            onChange={djPolicyHandler}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Star Rating</label>
                                                        <select name="starRating" onChange={formHandler} className='form-select' defaultValue={data?.starRating}>
                                                            <option value="" selected>Select Option</option>
                                                            <option value="1" >1 Star</option>
                                                            <option value="2" >2 Star</option>
                                                            <option value="3" >3 Star</option>
                                                            <option value="4" >4 Star</option>
                                                            <option value="5" >5 Star</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Max Capacity <span className='text-danger'>*</span></label>
                                                        <input type='text' placeholder='Venue Capacity' name="venueCapacity" value={data?.venueCapacity} onChange={formHandler} className='form-control' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group text-center'>
                                                <button className='btn btn-primary' >{ttkEditMode ? 'Save Changes' : 'Submit'}</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DestinationWedTTK